/**
 * product-zoom.js (FULL REPLACE) - Single click zoom cycle
 * PhotoSwipe v4 compatible
 *
 * Single tap/click zoom cycle:
 *   Fit -> MID (default 0.8) -> 1:1 (>= fit) -> Fit
 */

(function () {
  window.photoSwipeInstance = window.photoSwipeInstance || null;

  // 0.8~0.9 看起来更“高清”，默认 0.8
  var MID_ZOOM = 0.8;
  var EPS = 0.02;

  function getNextZoomLevel(gallery) {
    var item = gallery && gallery.currItem ? gallery.currItem : null;
    if (!item) return null;

    var fitZoom =
      typeof item.initialZoomLevel === "number" ? item.initialZoomLevel : 1;

    var midZoom = Math.max(fitZoom, MID_ZOOM);
    // 1:1，但不能比 fit 或 mid 小（小图时 fit 可能 >1）
    var fullZoom = Math.max(1, fitZoom, midZoom);

    var currZoom = fitZoom;
    try {
      if (gallery && typeof gallery.getZoomLevel === "function") {
        currZoom = gallery.getZoomLevel();
      }
    } catch (e) {}

    if (currZoom < midZoom - EPS) return midZoom;
    if (currZoom < fullZoom - EPS) return fullZoom;
    return fitZoom;
  }

  function getClickPoint(gallery, ev) {
    // PhotoSwipe zoomTo 需要 page 坐标
    // 如果拿不到点击点，就用视口中心
    try {
      if (ev && typeof ev.pageX === "number" && typeof ev.pageY === "number") {
        return { x: ev.pageX, y: ev.pageY };
      }
      // fallback：视口中心
      var vp = gallery.viewportSize || { x: window.innerWidth, y: window.innerHeight };
      var pageX = (window.pageXOffset || document.documentElement.scrollLeft || 0) + vp.x / 2;
      var pageY = (window.pageYOffset || document.documentElement.scrollTop || 0) + vp.y / 2;
      return { x: pageX, y: pageY };
    } catch (e) {
      return null;
    }
  }

  var initPhotoSwipeFromDOM = function (gallerySelector) {
    var parseThumbnailElements = function (el) {
      var thumbElements = el.childNodes,
        numNodes = thumbElements.length,
        items = [],
        listItem,
        childElements,
        size,
        item;

      for (var i = 0; i < numNodes; i++) {
        listItem = thumbElements[i];
        if (listItem.nodeType !== 1) continue;

        childElements = listItem.children;

        var d_size = listItem.getAttribute("data-size");
        if (!d_size) continue;
        size = d_size.split("x");

        var imgEl = null;
        if (childElements && childElements.length > 0) {
          imgEl = childElements[0];
        } else {
          imgEl = listItem.querySelector("img");
        }

        var zoomSrc =
          imgEl && imgEl.dataset && imgEl.dataset.zoomSrc
            ? String(imgEl.dataset.zoomSrc)
            : "";
        var hrefSrc =
          listItem.dataset && listItem.dataset.href
            ? String(listItem.dataset.href)
            : "";
        var originalSrc = (zoomSrc && zoomSrc.trim())
          ? zoomSrc.trim()
          : (hrefSrc || "").trim();

        item = {
          src: originalSrc,
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
          el: listItem
        };

        if (imgEl) {
          item.msrc = imgEl.getAttribute("src") || (imgEl.currentSrc || "");
        }

        if (childElements && childElements.length > 1) {
          item.title = childElements[1].innerHTML;
        }

        var mediumSrc = listItem.getAttribute("data-med");
        if (mediumSrc) {
          var medSize = listItem.getAttribute("data-med-size");
          if (medSize) {
            var msz = medSize.split("x");
            item.m = {
              src: mediumSrc,
              w: parseInt(msz[0], 10),
              h: parseInt(msz[1], 10)
            };
          }
        }

        item.o = { src: item.src, w: item.w, h: item.h };
        if (!item.m) item.m = item.o;

        items.push(item);
      }

      return items;
    };

    var closest = function closest(el, selector) {
      if (!el) return null;
      if (el.matches(selector)) return el;
      return closest(el.parentElement, selector);
    };

    var onThumbnailsClick = function (e) {
      e = e || window.event;
      if (e.preventDefault) e.preventDefault();
      else e.returnValue = false;

      var eTarget = e.target || e.srcElement;
      var clickedListItem = closest(eTarget, "div.slider-image");
      if (!clickedListItem) return;

      var clickedGallery = clickedListItem.parentNode;

      var childNodes = clickedListItem.parentNode.childNodes,
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) continue;
        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if (index >= 0) openPhotoSwipe(index, clickedGallery);
      return false;
    };

    var photoswipeParseHash = function () {
      var hash = window.location.hash.substring(1),
        params = {};

      if (hash.length < 5) return params;

      var vars = hash.split("&");
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) continue;
        var pair = vars[i].split("=");
        if (pair.length < 2) continue;
        params[pair[0]] = pair[1];
      }

      if (params.gid) params.gid = parseInt(params.gid, 10);
      return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = document.querySelectorAll(".pswp")[0];
      if (!pswpElement) return;

      var items = parseThumbnailElements(galleryElement);
      if (!items || !items.length) return;

      var options = {
        galleryUID: galleryElement.getAttribute("data-pswp-uid"),

        maxSpreadZoom: 4,
        mouseWheelZoom: true,

        /**
         * ✅ 单击缩放要稳定：关闭“单击关闭/单击切控件”，避免冲突
         * 关闭请用右上角 X
         */
        tapToClose: false,
        tapToToggleControls: false,

        /**
         * ✅ 禁用 PhotoSwipe 默认双击缩放（避免和单击逻辑叠加导致体验怪）
         * （你要保留双击也行，把这里删掉即可）
         */
        getDoubleTapZoom: function () {
          return false;
        },

        getThumbBoundsFn: function (idx) {
          idx = typeof idx === "number" ? idx : 0;
          if (!items[idx]) return;

          var thumbnail = items[idx].el.children[0];
          if (!thumbnail) return;

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },

        addCaptionHTMLFn: function (item, captionEl) {
          if (!item.title) {
            captionEl.children[0].innerText = "";
            return false;
          }
          return true;
        }
      };

      if (fromURL) {
        if (options.galleryPIDs) {
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      if (isNaN(options.index)) return;

      // 保留你原来的 radios 逻辑（如页面没有 radios，不影响）
      var radios = document.getElementsByName("gallery-style");
      for (var r = 0, len = radios.length; r < len; r++) {
        if (radios[r].checked) {
          if (radios[r].id == "radio-minimal-black") {
            options.mainClass = "pswp--minimal--dark";
            options.barsSize = { top: 0, bottom: 0 };
            options.captionEl = false;
            options.fullscreenEl = false;
            options.shareEl = false;
            options.bgOpacity = 0.8;
            options.tapToClose = false; // 仍然不允许单击关闭
            options.tapToToggleControls = false;
          }
          break;
        }
      }

      if (disableAnimation) options.showAnimationDuration = 0;

      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

      // ✅ 单击缩放：只在点到“图片区域”时触发，点按钮不触发
      var onPswpClickCapture = function (ev) {
        try {
          var t = ev.target;

          // 点到按钮/顶部栏/计数器等 UI：不拦截
          if (t && t.closest) {
            if (t.closest(".pswp__button")) return;
            if (t.closest(".pswp__top-bar")) return;
            if (t.closest(".pswp__caption")) return;
            if (t.closest(".pswp__counter")) return;
          }

          // 只要打开了 PhotoSwipe，单击就按循环缩放
          var nextZoom = getNextZoomLevel(gallery);
          if (nextZoom == null) return;

          // 用点击点作为缩放中心（更符合“单击放大到你点的位置”）
          var point = getClickPoint(gallery, ev);

          // zoomTo(zoomLevel, centerPoint, duration)
          // duration 给个很短的动画更顺滑
          gallery.zoomTo(nextZoom, point, 220);

          // 阻止这次点击继续被当作“切 UI / 其他”使用
          if (ev.preventDefault) ev.preventDefault();
          ev.stopPropagation();
        } catch (e) {
          // 不要让异常影响页面
        }
      };

      // 用 capture=true 更稳（PhotoSwipe 内部也会处理 click）
      pswpElement.addEventListener("click", onPswpClickCapture, true);

      gallery.listen("destroy", function () {
        try {
          pswpElement.removeEventListener("click", onPswpClickCapture, true);
        } catch (e) {}
      });

      var realViewportWidth,
        useLargeImages = false,
        firstResize = true,
        imageSrcWillChange;

      gallery.listen("beforeResize", function () {
        var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
        dpiRatio = Math.min(dpiRatio, 2.5);
        realViewportWidth = gallery.viewportSize.x * dpiRatio;

        if (
          realViewportWidth >= 1200 ||
          (!gallery.likelyTouchDevice && realViewportWidth > 800) ||
          screen.width > 1200
        ) {
          if (!useLargeImages) {
            useLargeImages = true;
            imageSrcWillChange = true;
          }
        } else {
          if (useLargeImages) {
            useLargeImages = false;
            imageSrcWillChange = true;
          }
        }

        if (imageSrcWillChange && !firstResize) {
          gallery.invalidateCurrItems();
        }

        if (firstResize) firstResize = false;
        imageSrcWillChange = false;
      });

      gallery.listen("gettingData", function (idx, item) {
        if (!item.m) item.m = item.o;
        if (!item.o) item.o = item.m;

        if (useLargeImages) {
          item.src = item.o.src;
          item.w = item.o.w;
          item.h = item.o.h;
        } else {
          item.src = item.m.src;
          item.w = item.m.w;
          item.h = item.m.h;
        }
      });

      gallery.init();
      window.photoSwipeInstance = gallery;
    };

    var galleryElements = document.querySelectorAll(gallerySelector);
    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute("data-pswp-uid", i + 1);
      galleryElements[i].addEventListener("click", onThumbnailsClick);
      galleryElements[i].addEventListener("keydown", function (event) {
        if (event.keyCode === 13) onThumbnailsClick.call(this, event);
      });
    }

    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
  };

  initPhotoSwipeFromDOM(".gallery-zoom");
})();
